module.exports = __webpack_public_path__ + "static/media/sync.d479c290.svg";